export enum TipoRealocacao {
    FUNCIONARIO_POSTO = 'FUNCIONARIO_POSTO',
    UNCIONARIO_EQUIPE = 'UNCIONARIO_EQUIPE',
    TROCA_FUNCIONARIO = 'TROCA_FUNCIONARIO',
}